import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { IInfoProps } from 'services/notificationService';

import { TOperationType } from './interfaces';

export const getNotificationData =
  (t: TTranslator<TLocalesKeys>) =>
  (operation: TOperationType, title: string): IInfoProps => {
    switch (operation) {
      case 'ADD':
        return {
          t,
          type: 'success',
          title: t('notification.warehouse.add.title'),
          message: `${title}`,
          dismiss: 3,
        };

      case 'DISPOSAL':
        return {
          t,
          type: 'success',
          title: t('notification.warehouse.disposal.title'),
          message: `${title}`,
          dismiss: 3,
        };
    }
  };
